<template>
<v-flex xs12 mb-2>
    <v-expansion-panel>
        <v-expansion-panel-content :class="color">

            <h2 slot="header" class="headline font-weight-medium">{{ `${metaData.label} | ${metaData.time}` }}</h2>

            <div class="lighten-4 px-3 py-4" :class="color" xs12>
                <v-layout class="mb-3">
                    <h4 class="display-1 pr-3" :class="{ 'green--text': studentEnrollment.complete, 'red--text': !studentEnrollment.complete }">
                        <span v-if="isPrimary && studentEnrollment.complete">
                {{ `Student is enrolled in ${metaData.label}` }}
              </span>
                        <span v-if="!isPrimary">
                {{ `Student is enrolled in: ${studentEnrollment.count} ${metaData.label}` }}
              </span>
                    </h4>
                    <v-icon large color="green" v-show="studentEnrollment.complete">check_circle</v-icon>
                    <v-spacer></v-spacer>
                </v-layout>
                <p class="title" v-html="metaData.message"></p>
            </div>

            <div class="px-3 py-5 white" v-for="(p, index) in periods" :key="index">
                <h5 class="headline font-weight-bold px-2">{{ p.text }}</h5>
                <v-layout class="lighten-4 row wrap align-center pa-3 my-3" :class="color" v-for="c in coursesList" :key="c.id" v-if="c.period === p.abbr">
                    <v-flex xs6>
                        <h4 class="title">{{ c.section }} | {{ c.name }}</h4>
                        <h4 class="title">{{ c.teacher.last_name }} | Grade: {{ sort(c.grade) }} | Rm: {{ c.room }}</h4>
                    </v-flex>
                    <v-flex xs6>
                        <v-btn v-if="c.current_seats >= c.max_seats" :disabled="true" color="red" style="float: right;">
                            Full
                        </v-btn>
                        <!-- <waitlist-btn v-else-if="(c.wait_list > 0) || (c.current_seats >= c.max_seats)" :course="c" :semester="semester">
                        </waitlist-btn> -->
                        <enroll-btn v-else :course="c" :semester="semester">
                        </enroll-btn>
                    </v-flex>
                    <v-flex xs12 mt-3>
                        <p class="subheading ma-0" v-html="c.description"></p>
                    </v-flex>
                </v-layout>
            </div>

        </v-expansion-panel-content>
    </v-expansion-panel>
</v-flex>
</template>

<script>
import enrollBtn from './enrollBtn'
import waitlistBtn from './waitlistBtn'
import {
    sortGrades,
    getGradeLevelNotes
} from '@/helpers/functions.js'

export default {
    components: {
        enrollBtn,
        waitlistBtn
    },
    props: {
        day: {
            type: String,
            required: true
        },
        color: {
            type: String,
            required: true
        },
        semester: {
            type: Object,
            required: true
        },
        grade: {
            type: String,
            required: true,
            default: ''
        }
    },
    computed: {
        coursesList() {
            let courses = this.$store.state.courseModule.semesterCourses
            return courses.filter(c => {
                if (c.active && (c.days === this.day) && c.grade.includes(this.grade)) {
                    return c
                }
            })
        },
        isPrimary() {
            return ['K', '1', '2', '3'].includes(this.grade)
        },
        metaData() {
            const notes = getGradeLevelNotes(this.semester, this.grade)
            const infoObj = {
                label: '',
                time: '',
                message: ''
            }
            switch (this.day) {
                case 'M':
                    infoObj.label = 'Monday Classes'
                    infoObj.time = notes.m.time
                    infoObj.message = notes.m.msg
                    break
                case 'T/TH':
                    infoObj.label = 'Tuesday/Thursday Classes'
                    infoObj.time = notes.t.time
                    infoObj.message = notes.t.msg
                    break
                case 'W':
                    infoObj.label = 'Wednesday Classes'
                    infoObj.time = notes.w.time
                    infoObj.message = notes.w.msg
                    break
                case 'F':
                    infoObj.label = 'Friday Classes'
                    infoObj.time = notes.f.time
                    infoObj.message = notes.f.msg
                    break
            }
            return infoObj
        },
        studentEnrollment() {
            const ss = this.$store.getters.formattedStudentSchedule
            const results = {
                complete: false,
                count: 0
            }
            switch (this.day) {
                case 'M':
                    results.count = ss.m.length
                    results.complete = (this.isPrimary && ss.m.length) || ss.m.length === 8 ? true : false
                    break
                case 'T/TH':
                    results.count = ss.t.length
                    results.complete = (this.isPrimary && ss.t.length) || ss.t.length === 6 ? true : false
                    break
                case 'W':
                    results.count = ss.w.length
                    results.complete = (this.isPrimary && ss.w.length) ? true : false
                    break
                case 'F':
                    results.count = ss.f.length
                    results.complete = (this.isPrimary && ss.f.length) ? true : false
                    break
            }
            return results
        },
        periods() {
            if (this.isPrimary) {
                if (this.grade === '3' && (this.day === 'F' || this.day === 'W')) {
                    return [{
                            text: 'All Day Schedule',
                            abbr: 'All Day'
                        },
                        {
                            text: 'Optional Classes',
                            abbr: 'Optional'
                        }
                    ]
                }
                return [{
                    text: 'All Day Schedule',
                    abbr: 'All Day'
                }]
            } else if (this.day === 'W' && this.semester.name === 'Spring 2023') {
                return [{
                        text: 'All Day Schedule',
                        abbr: 'All Day'
                    },
                    {
                        text: 'Optional Classes',
                        abbr: 'Optional'
                    }
                ]
            } else if (this.day === 'W') {
                return [{
                        text: 'Period 1',
                        abbr: '1'
                    },
                    {
                        text: 'Periods 2-6',
                        abbr: '2'
                    }
                ]
            } else if (this.day === 'M' || this.day === 'F') {
                return [{
                        text: 'Period 1',
                        abbr: '1'
                    },
                    {
                        text: 'Period 2',
                        abbr: '2'
                    },
                    {
                        text: 'Period 3',
                        abbr: '3'
                    },
                    {
                        text: 'Period 4 - Lunch 11:30-12:10',
                        abbr: '4',
                    },
                    {
                        text: 'Period 5',
                        abbr: '5'
                    },
                    {
                        text: 'Period 6',
                        abbr: '6'
                    },
                    {
                        text: 'Period 7',
                        abbr: '7'
                    }
                ]
            } else if (this.day === 'T/TH') {
                return [{
                        text: 'Period 1',
                        abbr: '1'
                    },
                    {
                        text: 'Period 2',
                        abbr: '2'
                    },
                    {
                        text: 'Period 3',
                        abbr: '3'
                    },
                    {
                        text: 'Period 4 - Lunch 11:30-12:10',
                        abbr: '4',
                    },
                    {
                        text: 'Period 5',
                        abbr: '5'
                    },
                    {
                        text: 'Period 6',
                        abbr: '6'
                    }
                ]
            }
        }
    },
    methods: {
        sort(grades) {
            return sortGrades(grades)
        }
    }
}
</script>
